import React, { useEffect, useState } from "react";
import { HashLink as Link } from "react-router-hash-link";

const AboutM = () => {
  const [planData, setPlanData] = useState(null);
  const [loading, setLoading] = useState(true);

  const normalizeStatus = (value) => {
    if (
      value === "active" ||
      value === 1 ||
      value === "1" ||
      value === true ||
      value === "true"
    ) {
      return "active";
    }
    return "inactive";
  };

  useEffect(() => {
    const fetchReadyToPlanData = async () => {
      try {
        setLoading(true);

        const response = await fetch(
          "https://eventscons.com/eventbackendnew/api/ready-to-plan-list"
        );
        const result = await response.json();

        if (
          result?.status &&
          Array.isArray(result?.data) &&
          result.data.length > 0
        ) {
          setPlanData(result.data[0]);
        }
      } catch (error) {
        console.error("Ready to plan API fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReadyToPlanData();
  }, []);

  if (loading) {
    return (
      <section
        className="about-section"
        style={{ backgroundColor: "#fff", padding: "20px 0" }}
      >
        <div className="container">
          <p>Loading...</p>
        </div>
      </section>
    );
  }

  if (!planData) {
    return null;
  }

  const currentStatus = normalizeStatus(
    planData?.status ?? planData?.is_active ?? planData?.section_status ?? "inactive"
  );

  if (currentStatus === "inactive") {
    return null;
  }

  return (
    <>
      <section
        className="about-section"
        style={{ backgroundColor: "#fff", overflow: "hidden", padding: "20px 0"  }}
      >
        <div className="container-fluid p-0">
          <div
            className="row g-0 align-items-stretch"
            style={{ minHeight: "550px" }}
          >
            {/* Left Narrow White Bar */}
            <div
              className="col-lg-1 d-none d-lg-flex align-items-center justify-content-center"
              style={{ backgroundColor: "#fff", width: "10%" }}
            >
              <div
                style={{
                  width: "100%",
                  height: "260px",
                  backgroundColor: "#f5f5f5",
                  margin: "0 0px",
                }}
              ></div>
            </div>

            {/* Main Content Column */}
            <div
              className="col-lg-5 col-md-12 d-flex align-items-center"
              style={{
                backgroundColor: "#000",
                color: "#fff",
                padding: "80px 6%",
              }}
            >
              <div className="inner-column">
                <h2
                  style={{
                    fontSize: "45px",
                    textAlign: "left",
                    color: "#fff",
                    fontWeight: "700",
                    marginBottom: "25px",
                    lineHeight: "1.1",
                  }}
                >
                  {planData?.heading}
                </h2>

                <p
                  style={{
                    fontSize: "18px",
                    lineHeight: "1.6",
                    color: "#cecece",
                    marginBottom: "40px",
                    maxWidth: "500px",
                  }}
                >
                  {planData?.text}
                </p>

                <div className="btn-box">
                  {planData?.button_link?.startsWith("/") ? (
                    <Link
                      to={planData.button_link}
                      className="theme-btn"
                      style={{
                        backgroundColor: "#b21e35",
                        color: "#fff",
                        padding: "16px 35px",
                        textDecoration: "none",
                        fontWeight: "600",
                        display: "inline-block",
                        fontSize: "16px",
                      }}
                    >
                      {planData?.button_text}
                    </Link>
                  ) : (
                    <a
                      href={planData?.button_link}
                      className="theme-btn"
                      style={{
                        backgroundColor: "#b21e35",
                        color: "#fff",
                        padding: "16px 35px",
                        textDecoration: "none",
                        fontWeight: "600",
                        display: "inline-block",
                        fontSize: "16px",
                      }}
                    >
                      {planData?.button_text}
                    </a>
                  )}
                </div>
              </div>
            </div>

            {/* Right Image Column */}
            <div className="col-lg-5 col-md-12">
              <div
                className="image-box"
                style={{ height: "100%", width: "100%" }}
              >
                <img
                  src={planData?.image}
                  alt={planData?.heading || "Ready to Plan"}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutM;